module.exports = __webpack_public_path__ + "static/media/ios-grid.6361f0df.svg";